<div class="sidebar">
	<app-sidebar-header [title]="'extrasSidebar.useMilesInfo.title.usingMiles' | ibeadmin | async"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" id="sidebar__body" #sidebar__body>
		<div class="sidebar__image">
			<img src="assets/images/banner_milesgo.svg" alt="Miles&GO banner image" />
		</div>

		<p class="miles-top-message">{{ 'extrasSidebar.useMilesInfo.text.didYouKnow' | ibeadmin | async }}<p>

		<!-- login (has miles to pay extras) -->
		<p class="miles-top-message miles-top-message--sub" *ngIf="hasLogin && (userMiles >= minMilesNeeded)"> 
			{{ 'extrasSidebar.useMilesInfo.text.youCanChooseTheDiscouts' | ibeadmin | async }}
		</p>

		<p class="miles-top-message miles-top-message--sub" *ngIf="!hasLogin">
			<a href="javascript:;" class="link" (click)=INDRA_handleLogin()>{{ 'extrasSidebar.useMilesInfo.text.login' | ibeadmin | async }}</a> {{ 'extrasSidebar.useMilesInfo.text.toUseMilesToPay' | ibeadmin | async }}
		</p>

		<h2 class="title-h2" [innerHTML]=INDRA_getMilesTitle()></h2>

		<section class="pay-with-miles-section" *ngIf="ancillariesFromFlights.length && (INDRA_canAdd() || INDRA_cannotAdd() || INDRA_cannotBuyExtrasAdded() || ancillaryListCanPay.length)">
			<h3 class="title-miles-section">
				<app-svg aria-hidden="true" [alt]="'Long arrow'" [svg]="'icons.svg#general--arrow--long_right'"></app-svg>
				{{ 'extrasSidebar.useMilesInfo.text.payForExtrasAdded' | ibeadmin | async }}
			</h3>

			<!-- no extras - login (has miles to pay extras) -->
			<p class="miles-section-message" *ngIf="INDRA_canAdd() && suggestions && suggestions.length > 0">
				{{ 'extrasSidebar.useMilesInfo.text.add' | ibeadmin | async }}
				<ng-container *ngFor="let extra of suggestions; let i = index">
					<a href="javascript:;" class="link" (click)="INDRA_handleExtraSidebar(extra)"> {{ INDRA_getExtraName(extra.type) }} </a> {{ 'extrasSidebar.useMilesInfo.text.from' | ibeadmin | async }} {{ extra.points }} M{{ INDRA_separator(i) }}
				</ng-container>
			</p>

			<!-- no extras - not enough miles to pay extras -->
			<p class="miles-section-message" *ngIf="INDRA_cannotAdd() && suggestions && suggestions.length > 0">
				{{ 'extrasSidebar.useMilesInfo.text.youWillBeAbleToBuy' | ibeadmin | async }}
				<ng-container *ngFor="let extra of suggestions; let i = index">
					{{ INDRA_getExtraName(extra.type) }} {{ 'extrasSidebar.useMilesInfo.text.from' | ibeadmin | async }} {{ extra.points }} M{{ INDRA_separator(i) }}
				</ng-container>
			</p>

			<ul class="pay-with-miles-section-items" *ngIf="hasExtras" role="list">
				<!-- not login / has extras but not enough miles to pay -->
				<ng-container *ngIf="INDRA_cannotBuyExtrasAdded(); else ancillariesToPay">
					<li *ngFor="let extra of ancillaryList" class="pay-with-miles-section-item" role="listitem">
						<div class="pay-with-miles-section-item__left">
							<span class="pay-with-miles-section-item__label">{{ INDRA_getExtraName(extra.type) }}</span>
						</div>
						<div class="pay-with-miles-section-item__right">
							<span class="pay-with-miles-section-item__price" [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.price' | ibeadmin | async">{{ extra.price + currency | indracurrency }}</span>
							<span class="pay-with-miles-section-item__discount" [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.milesPrice' | ibeadmin | async">{{ extra.points | indracurrency : 'M' }}</span>
						</div>
					</li>
				</ng-container>
				<!-- has enough miles to pay extras -->
				<ng-template #ancillariesToPay>
					<li *ngFor="let extra of ancillaryListCanPay" class="pay-with-miles-section-item" role="listitem">
						<div class="pay-with-miles-section-item__left">
							<span class="pay-with-miles-section-item__label">{{ INDRA_getExtraName(extra.type) }}</span>
						</div>
						<div class="pay-with-miles-section-item__right">
							<span class="pay-with-miles-section-item__price" [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.price' | ibeadmin | async">{{ extra.price + currency | indracurrency }}</span>
							<span class="pay-with-miles-section-item__discount" [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.milesPrice' | ibeadmin | async">{{ extra.points | indracurrency : 'M' }}</span>
						</div>
					</li>
				</ng-template>
			</ul>
		</section>

		<!-- display max miles user can use if user can pay for flight discount, otherwise display max conversion of base flight price -->
		<section class="pay-with-miles-section" *ngIf="conversionRates.length && !bookAwardFlights">
			<h3 class="title-miles-section">
				<app-svg aria-hidden="true" [alt]="'Long arrow'" [svg]="'icons.svg#general--arrow--long_right'"></app-svg>
				{{ 'extrasSidebar.useMilesInfo.text.saveUpTo' | ibeadmin | async }} {{ (milesNotEnoughForMinFlightDiscount ? maxConvertedCash + currency : maxToUseConvertedCash + currency) | indracurrency }} {{ 'extrasSidebar.useMilesInfo.text.inYourFlights' | ibeadmin | async }}
			</h3>

			<ul class="pay-with-miles-section-items" role="list">
				<li class="pay-with-miles-section-item" role="listitem">
					<div class="pay-with-miles-section-item__left">
						<span class="pay-with-miles-section-item__label">{{ 'extrasSidebar.useMilesInfo.text.flights' | ibeadmin | async }}</span>
					</div>
					<div class="pay-with-miles-section-item__right">
						<span class="pay-with-miles-section-item__price" [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.price' | ibeadmin | async">{{ flightTotalPrice + currency | indracurrency }}</span>
						<span class="pay-with-miles-section-item__discount" [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.milesPrice' | ibeadmin | async">{{ (milesNotEnoughForMinFlightDiscount ? maxConversion : maxToUseConversion) | indracurrency : 'M' }} + {{ INDRA_getDiscountedFlightPrice() + currency | indracurrency }}</span>
					</div>
				</li>
			</ul>

			<p class="miles-note" *ngIf="promoMiles && promoMiles.discount != maxConvertedCash">
				{{ 'extrasSidebar.useMilesInfo.text.youWillBeAbleToChoose' | ibeadmin | async }} {{ promoMiles.discount + currency | indracurrency }} {{ 'extrasSidebar.useMilesInfo.text.and' | ibeadmin | async }} {{ (milesNotEnoughForMinFlightDiscount ? maxConvertedCash + currency : maxToUseConvertedCash + currency) | indracurrency }}
			</p>
		</section>


		<div class="loggin-wrapper" *ngIf="!hasLogin">
			<button class="button" (click)=INDRA_handleLogin() [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.openDialogToLogin' | ibeadmin | async">{{ 'extrasSidebar.useMilesInfo.text.loginToUseMiles' | ibeadmin | async }}</button>
			<p class="miles-top-message" *ngIf="!hasLogin">{{ 'extrasSidebar.useMilesInfo.text.dontHaveAccount' | ibeadmin | async }}<br>
				<a href="javascript:;" class="link" (click)=INDRA_handleNewAccount() [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.openDialogToCreateAccount' | ibeadmin | async">{{ 'extrasSidebar.useMilesInfo.text.createAnAccountNow' | ibeadmin | async }}</a> {{ 'extrasSidebar.useMilesInfo.text.andGetDiscounts' | ibeadmin | async }}</p>
		</div>

		<div class="keep-flying-wrapper" *ngIf="hasLogin">
			<app-miles-balance-animation aria-hidden="true" alt="Miles balance animation"></app-miles-balance-animation>
			<span class="keep-flying-message">{{ 'extrasSidebar.useMilesInfo.text.keepFlyingWithTap' | ibeadmin | async }}</span>
		</div>

		<!-- display items user cannot pay using miles -->
		<div class="insufficient-miles-wrapper"
			*ngIf="hasLogin && INDRA_canPayUsingMiles() && ( INDRA_cannotBuyMaxFlightDiscount() || ancillaryListCannotPay.length )">
			<h2 class="title-h2">{{ 'extrasSidebar.useMilesInfo.text.ifYouHadMoreMiles' | ibeadmin | async }}</h2>

			<!-- display added extras user cannot pay using miles -->
			<section class="pay-with-miles-section" *ngIf="ancillaryListCannotPay.length">
				<h3 class="title-miles-section">
					<app-svg aria-hidden="true" [alt]="'Long arrow'" [svg]="'icons.svg#general--arrow--long_right'"></app-svg>
					{{ 'extrasSidebar.useMilesInfo.text.onYourOtherExtras' | ibeadmin | async }}
				</h3>

				<ul class="pay-with-miles-section-items" role="list">
					<li *ngFor="let extra of ancillaryListCannotPay" class="pay-with-miles-section-item" role="listitem">
						<div class="pay-with-miles-section-item__left">
							<span class="pay-with-miles-section-item__label">{{ INDRA_getExtraName(extra.type) }}</span>
						</div>
						<div class="pay-with-miles-section-item__right">
							<span class="pay-with-miles-section-item__price" [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.price' | ibeadmin | async">{{ extra.price + currency | indracurrency }}</span>
							<span class="pay-with-miles-section-item__discount" [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.milesPrice' | ibeadmin | async">{{ extra.points | indracurrency : 'M' }}</span>
						</div>
					</li>
				</ul>
			</section>

			<!-- display max conversion of base flight price if user cannot pay fully  -->
			<section class="pay-with-miles-section" *ngIf="INDRA_cannotBuyMaxFlightDiscount()">
				<h3 class="title-miles-section">
					<app-svg aria-hidden="true" [alt]="'Long arrow'" [svg]="'icons.svg#general--arrow--long_right'"></app-svg>
					{{ 'extrasSidebar.useMilesInfo.text.saveUpTo' | ibeadmin | async }} {{ maxConvertedCash + currency | indracurrency }} {{ 'extrasSidebar.useMilesInfo.text.inYourFlights' | ibeadmin | async }}
				</h3>

				<ul class="pay-with-miles-section-items" role="list">
					<li class="pay-with-miles-section-item" role="listitem">
						<div class="pay-with-miles-section-item__left">
							<span class="pay-with-miles-section-item__label">{{ 'extrasSidebar.useMilesInfo.text.flights' | ibeadmin | async }}</span>
						</div>
						<div class="pay-with-miles-section-item__right">
							<span class="pay-with-miles-section-item__price" [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.price' | ibeadmin | async">{{ flightTotalPrice + currency | indracurrency }}</span>
							<span class="pay-with-miles-section-item__discount" [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.milesPrice' | ibeadmin | async">{{ maxConversion | indracurrency : 'M' }} + {{ (flightTotalPrice - maxConvertedCash) + currency | indracurrency }}</span>
						</div>
					</li>
				</ul>
			</section>
		</div>
		<div class="sidebar-close top-gap">
			<a class="link link--close" [attr.aria-label]="'extrasSidebar.useMilesInfo.aria.closeSidebar' | ibeadmin | async" (click)="INDRA_handleClose()" href="javascript:;"
				role="button">{{ 'extrasSidebar.useMilesInfo.text.closeThisWindow' | ibeadmin | async }}</a>
		</div>
	</div>
</div>
